"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6418],{

/***/ 99025:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68426);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50556);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98716);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47361);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10430);









var Desktop = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "compositions-Header-view-Desktop-Desktop";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | compositions-Header-view-Desktop-Desktop */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6471), __webpack_require__.e(6102), __webpack_require__.e(255), __webpack_require__.e(8371), __webpack_require__.e(7936), __webpack_require__.e(8101), __webpack_require__.e(5800), __webpack_require__.e(6418), __webpack_require__.e(9313), __webpack_require__.e(5742), __webpack_require__.e(8982), __webpack_require__.e(2236), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(7288)]).then(__webpack_require__.bind(__webpack_require__, 789));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(789);
        }
        return eval("require.resolve")("compositions/Header/view/Desktop/Desktop");
    }
}, {
    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: "bg-black",
        pw: 100,
        h: 64
    })
});
var Mobile = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "compositions-Header-view-Mobile-Mobile";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | compositions-Header-view-Mobile-Mobile */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7369), __webpack_require__.e(6471), __webpack_require__.e(255), __webpack_require__.e(8371), __webpack_require__.e(7936), __webpack_require__.e(8101), __webpack_require__.e(5800), __webpack_require__.e(6418), __webpack_require__.e(9313), __webpack_require__.e(5742), __webpack_require__.e(8982), __webpack_require__.e(2236), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(1821)]).then(__webpack_require__.bind(__webpack_require__, 1317));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(1317);
        }
        return eval("require.resolve")("compositions/Header/view/Mobile/Mobile");
    }
}, {
    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: "bg-black",
        pw: 100,
        h: 48
    })
});
var Header = function(props) {
    var withBanner = props.withBanner, withSubHeader = props.withSubHeader, withSupNav = props.withSupNav, withInAppMessagesCounter = props.withInAppMessagesCounter, withQueueCounter = props.withQueueCounter, loginWithBackRedirect = props.loginWithBackRedirect, logoLink = props.logoLink;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().isMobile;
    var isChatAssistanceEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.features.budgieChatAssistance);
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Mobile, {
            withBanner: withBanner,
            withSubHeader: withSubHeader,
            logoLink: logoLink,
            withInAppMessagesCounter: withInAppMessagesCounter,
            withQueueCounter: withQueueCounter,
            loginWithBackRedirect: loginWithBackRedirect
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Desktop, {
        withBanner: withBanner,
        withSupNav: withSupNav,
        logoLink: logoLink,
        withQueueCounter: withQueueCounter,
        withInAppMessagesCounter: withInAppMessagesCounter,
        loginWithBackRedirect: loginWithBackRedirect,
        withChatAssistance: isChatAssistanceEnabled
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Header);


/***/ }),

/***/ 18223:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Banner_Banner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/compositions/banners/SubscribeHeaderBanner/SubscribeHeaderBanner.tsx + 1 modules
var SubscribeHeaderBanner = __webpack_require__(16411);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(59690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(8946);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(34618);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.dot-all.js
var es_regexp_dot_all = __webpack_require__(73525);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.sticky.js
var es_regexp_sticky = __webpack_require__(864);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(61737);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(46781);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/hooks/useExpiration.ts
var useExpiration = __webpack_require__(41501);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
// EXTERNAL MODULE: ./src/modules/subscription/subscriptionAddons/index.ts + 5 modules
var subscriptionAddons = __webpack_require__(4833);
// EXTERNAL MODULE: ./src/modules/products/usePrivateSale.ts + 1 modules
var usePrivateSale = __webpack_require__(28733);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/util/useBanner.ts


















var normalizePagePaths = function(pagePaths) {
    return pagePaths.map(function(link) {
        return link.replace("(.*)", "").replace(":slug", "");
    }).join("|");
};
var productPagePaths = normalizePagePaths([
    links/* default */.ZP.productGeneral,
    links/* default */.ZP.productCandle,
    links/* default */.ZP.productExtra,
    links/* default */.ZP.productMakeup,
    links/* default */.ZP.productPerfume,
    links/* default */.ZP.productPerfumeLanding,
    links/* default */.ZP.productPersonalCare,
    links/* default */.ZP.productSkincare,
    links/* default */.ZP.productWellness,
    links/* default */.ZP.productDiffuser,
    links/* default */.ZP.productAccessory
]);
var productPagePathRegExp = new RegExp("^(".concat(productPagePaths, ")"));
var useBanner = function() {
    var pathname = (0,contexts/* usePathname */.jD)();
    var _useUser = (0,user/* useUser */.a)(), isLoggedIn = _useUser.isLoggedIn, isUserFetching = _useUser.isFetching;
    var _useSubscription = (0,subscription_subscription/* useSubscription */.m)(), subscription = _useSubscription.subscription, isSubscriptionFetching = _useSubscription.isFetching;
    var _usePrivateSale = (0,usePrivateSale/* default */.Z)(), privateSale = _usePrivateSale.privateSale, isPrivateSaleFetching = _usePrivateSale.isFetching;
    var _useCandleSubscription = (0,subscriptionAddons/* useCandleSubscription */.pj)(), candleSubscription = _useCandleSubscription.candleSubscription, isCandleSubscriptionFetching = _useCandleSubscription.isFetching;
    var driftSubscription = (0,subscriptionAddons/* useDriftSubscription */.RD)().driftSubscription;
    var isGiftHubEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftHub);
    var isHolidayMothersDayEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holidayMothersDay);
    var isHolidayFathersDayEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holidayFathersDay);
    var is15percentDiscountEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holiday22SaleBadge15);
    var is20percentDiscountEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holiday22SaleBadge20);
    var isBlackFridayBannerEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.blackFridayTopHomePageBanner);
    var isCyberMondayBannerEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.cyberMondayTopHomePageBanner);
    var isDriftSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftSubscription);
    var isDriftSubscriptionLaunchPromoEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftSubscriptionLaunchPromo);
    var isBfcmNotificationEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.bfcmNotification);
    var isGiftSubscriptionNotificationEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftSubscriptionNotification);
    var isFetching = isUserFetching || isSubscriptionFetching || isPrivateSaleFetching || isCandleSubscriptionFetching;
    var isSubscribeBannerVisible = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) && pathname !== links/* default */.ZP.subscription.main && !productPagePathRegExp.test(pathname);
    // show banner only when subscription is in undeliverable status
    var isUndeliverableBannerVisible = subscription === null || subscription === void 0 ? void 0 : subscription.isUndeliverable;
    var isCardUpdateBannerVisible = subscription === null || subscription === void 0 ? void 0 : subscription.isUnpaid;
    var isTossInBannerVisible = isLoggedIn && pathname !== links/* default */.ZP.tossIn && (subscription === null || subscription === void 0 ? void 0 : subscription.canApplyTossInOffer);
    var isHolidayBanner15Visible = is15percentDiscountEnabled && pathname !== links/* default */.ZP.shop.holiday;
    var isHolidayBanner20Visible = is20percentDiscountEnabled && pathname !== links/* default */.ZP.shop.holiday;
    var isBfcmBannerVisible = isBfcmNotificationEnabled && pathname === links/* default */.ZP.shop.holiday;
    var isGiftSubscriptionBannerVisible = isGiftSubscriptionNotificationEnabled && pathname === links/* default */.ZP.giftSubscription;
    var isHolidayBannerVisible = isGiftHubEnabled && !isHolidayMothersDayEnabled && !isHolidayFathersDayEnabled && !isBfcmBannerVisible && !isGiftSubscriptionBannerVisible && pathname !== links/* default */.ZP.gifts;
    var isHolidayMothersDayVisible = isGiftHubEnabled && isHolidayMothersDayEnabled && pathname !== links/* default */.ZP.gifts;
    var isHolidayFathersDayVisible = isGiftHubEnabled && isHolidayFathersDayEnabled && pathname !== links/* default */.ZP.gifts;
    var isBlackFridayBannerVisible = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) && isBlackFridayBannerEnabled && (pathname === links/* default */.ZP.home || pathname === links/* default */.ZP.homeMen);
    var isCyberMondayBannerVisible = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) && isCyberMondayBannerEnabled && (pathname === links/* default */.ZP.home || pathname === links/* default */.ZP.homeMen);
    var isPrivateSaleExpired = (0,useExpiration/* default */.Z)({
        timeLeft: privateSale === null || privateSale === void 0 ? void 0 : privateSale.timeLeft
    });
    var isPrivateSaleBannerVisible = isLoggedIn && pathname !== links/* default */.ZP.privateSale && Boolean(privateSale) && !isPrivateSaleExpired;
    var isUnskipBannerVisible = isLoggedIn && (subscription === null || subscription === void 0 ? void 0 : subscription.isOnHold) && Boolean(subscription === null || subscription === void 0 ? void 0 : subscription.activeHold);
    var isCandleSubscriptionBannerVisible = (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled) && !(candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected) && pathname !== links/* default */.ZP.candleSubscription && pathname !== links/* default */.ZP.featuredCandle;
    var isDriftSubscriptionVisible = isDriftSubscriptionEnabled && (driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isEnabled) && !(driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isSelected) && pathname !== links/* default */.ZP.driftSubscription;
    var isDriftSubscriptionHasLaunchPriority = isDriftSubscriptionLaunchPromoEnabled;
    var isResubscribeBannerVisible = Boolean(subscription === null || subscription === void 0 ? void 0 : subscription.isCancelled);
    return {
        isFetching: isFetching,
        isCardUpdateBannerVisible: isCardUpdateBannerVisible,
        isSubscribeBannerVisible: isSubscribeBannerVisible,
        isUndeliverableBannerVisible: isUndeliverableBannerVisible,
        isTossInBannerVisible: isTossInBannerVisible,
        isPrivateSaleBannerVisible: isPrivateSaleBannerVisible,
        isUnskipBannerVisible: isUnskipBannerVisible,
        isCandleSubscriptionBannerVisible: isCandleSubscriptionBannerVisible,
        isHolidayBannerVisible: isHolidayBannerVisible,
        isHolidayBanner15Visible: isHolidayBanner15Visible,
        isHolidayBanner20Visible: isHolidayBanner20Visible,
        isHolidayMothersDayVisible: isHolidayMothersDayVisible,
        isHolidayFathersDayVisible: isHolidayFathersDayVisible,
        isBlackFridayBannerVisible: isBlackFridayBannerVisible,
        isCyberMondayBannerVisible: isCyberMondayBannerVisible,
        isResubscribeBannerVisible: isResubscribeBannerVisible,
        isDriftSubscriptionVisible: isDriftSubscriptionVisible,
        isDriftSubscriptionHasLaunchPriority: isDriftSubscriptionHasLaunchPriority,
        isBfcmBannerVisible: isBfcmBannerVisible,
        isGiftSubscriptionBannerVisible: isGiftSubscriptionBannerVisible
    };
};
/* harmony default export */ const util_useBanner = (useBanner);

// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.tsx + 1 modules
var HeaderBannerContainer = __webpack_require__(39450);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CardUpdateBanner/messages.ts
/* harmony default export */ const CardUpdateBanner_messages = ({
    text: {
        en: 'Your card was declined, <br class="onlyMobile" />please update your payment info'
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CardUpdateBanner/CardUpdateBanner.tsx









var CardUpdateBanner = function() {
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        className: "z-floating-header sticky top-0 bg-red",
        height: 64,
        to: links/* default */.ZP.cardUpdate,
        trackParams: {
            placement: "Header",
            content: "Payment method update",
            action: "link",
            link: links/* default */.ZP.cardUpdate
        },
        "data-testid": "headerCardUpdateBanner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex  items-center", isMobile ? "justify-between" : "justify-center"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: isMobile ? "sh6" : "sh5",
                    message: CardUpdateBanner_messages.text,
                    html: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "ml-24 flex-none",
                    title: messages/* default */.Z.update,
                    size: 38,
                    tabIndex: -1
                })
            ]
        })
    });
};
/* harmony default export */ const CardUpdateBanner_CardUpdateBanner = (CardUpdateBanner);

// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/UndeliverableBanner/messages.ts
/* harmony default export */ const UndeliverableBanner_messages = ({
    message: {
        en: "Subscription paused, due to a wrong shipping address"
    },
    button: {
        en: "Update your shipping address"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/UndeliverableBanner/UndeliverableBanner.tsx








var UndeliverableBanner = function() {
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        className: "bg-red",
        height: 64,
        to: links/* default */.ZP.profile.shipping,
        trackParams: {
            placement: "Header",
            content: "Undeliverable address",
            action: "link",
            link: links/* default */.ZP.profile.shipping
        },
        "data-testid": "undeliverableBanner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex items-center justify-center", isMobile ? "flex-col" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: isMobile ? "sh6" : "sh5",
                    message: UndeliverableBanner_messages.message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)("flex flex-none items-center", isMobile ? "mt-4" : "ml-24"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: "h7",
                            message: UndeliverableBanner_messages.button
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            className: "ml-12 flex-none",
                            name: "other/long-arrow-right"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const UndeliverableBanner_UndeliverableBanner = (UndeliverableBanner);

// EXTERNAL MODULE: ./src/components/dataDisplay/Carousel/Carousel.tsx + 2 modules
var Carousel = __webpack_require__(99868);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BannersCarousel/BannersCarousel.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const BannersCarousel_module = ({"carousel":"mnJuzW"});
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BannersCarousel/BannersCarousel.tsx






var BannersCarousel = function(props) {
    var children = props.children;
    // return one banner as is
    if (react.Children.count(children) <= 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
        className: (0,clsx/* default */.Z)("relative overflow-hidden", BannersCarousel_module.carousel),
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        rewind: true,
        withDots: true,
        draggable: true,
        children: react.Children.map(children, function(child, index) {
            if (!/*#__PURE__*/ (0,react.isValidElement)(child)) {
                return child;
            }
            return /*#__PURE__*/ react.cloneElement(child, {
                className: "pb-12",
                position: index + 1
            });
        })
    });
};
/* harmony default export */ const BannersCarousel_BannersCarousel = (BannersCarousel);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BannerBase/BannerBase.tsx






var BannerBase = function(props) {
    var className = props.className, title = props.title, _props_titleStyle = props.titleStyle, titleStyle = _props_titleStyle === void 0 ? "h8" : _props_titleStyle, customHeight = props.height, to = props.to, loading = props.loading, html = props.html, trackParams = props.trackParams, onClick = props.onClick, dataTestId = props["data-testid"];
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var height = customHeight || (isMobile ? 48 : 56);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderBannerContainer/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, "bg-gold-50"),
        to: to,
        height: height,
        loading: loading,
        trackParams: trackParams,
        onClick: onClick,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: titleStyle,
                message: title,
                html: html
            }),
            Boolean(to) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: "ml-12 flex-none",
                name: "other/long-arrow-right"
            })
        ]
    });
};
/* harmony default export */ const BannerBase_BannerBase = (BannerBase);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/TossInBanner/messages.ts
/* harmony default export */ const TossInBanner_messages = ({
    title: {
        en: "Product add-ons, at a discount"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/TossInBanner/TossInBanner.tsx






var TossInBanner = function(param) {
    var className = param.className, position = param.position;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase_BannerBase, {
        className: className,
        title: TossInBanner_messages.title,
        to: links/* default */.ZP.tossIn,
        height: isMobile ? 64 : 56,
        trackParams: {
            placement: "Header",
            content: "Toss-in",
            action: "link",
            link: links/* default */.ZP.tossIn,
            position: position
        },
        "data-testid": "tossInBanner"
    });
};
/* harmony default export */ const TossInBanner_TossInBanner = (TossInBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/PrivateSaleBanner/messages.ts
/* harmony default export */ const PrivateSaleBanner_messages = ({
    title: {
        en: "Limited time private sale, happening now!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/PrivateSaleBanner/PrivateSaleBanner.tsx






var PrivateSaleBanner = function(param) {
    var className = param.className, position = param.position;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase_BannerBase, {
        className: className,
        title: PrivateSaleBanner_messages.title,
        titleStyle: isMobile ? "eye2" : undefined,
        to: links/* default */.ZP.privateSale,
        height: isMobile ? 64 : 56,
        trackParams: {
            placement: "Header",
            content: "Private sale",
            action: "link",
            link: links/* default */.ZP.privateSale,
            position: position
        },
        "data-testid": "privateSaleBanner"
    });
};
/* harmony default export */ const PrivateSaleBanner_PrivateSaleBanner = (PrivateSaleBanner);

// EXTERNAL MODULE: ./src/compositions/buttons/UnskipButton/util/useUnskipSubscription.ts + 2 modules
var useUnskipSubscription = __webpack_require__(86299);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/UnskipBanner/messages.ts
/* harmony default export */ const UnskipBanner_messages = ({
    subTitle: {
        en: "Get access to over 700 designer & niche fragrances"
    },
    title: {
        en: "Cancel skipped month"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/UnskipBanner/UnskipBanner.tsx








var UnskipBanner = function() {
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useUnskipSubscription = (0,useUnskipSubscription/* default */.Z)({
        placement: "banner"
    }), handleUnskipSubscription = _useUnskipSubscription.handleUnskipSubscription, isSubmitting = _useUnskipSubscription.isSubmitting, isFetching = _useUnskipSubscription.isFetching;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        height: 64,
        className: "bg-gold-50",
        loading: isFetching || isSubmitting,
        trackParams: {
            placement: "Header",
            content: "Unskip"
        },
        onClick: handleUnskipSubscription,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex items-center justify-center", isMobile ? "flex-col" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: isMobile ? "sh6" : "sh5",
                    message: UnskipBanner_messages.subTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)("flex flex-none items-center", isMobile ? "mt-4" : "ml-24"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: "h7",
                            message: UnskipBanner_messages.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            className: "ml-12 flex-none",
                            name: "other/long-arrow-right"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const UnskipBanner_UnskipBanner = (UnskipBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CandleSubscriptionBanner/messages.ts
/* harmony default export */ const CandleSubscriptionBanner_messages = ({
    title: {
        en: "Treat yourself to a new scented candle every month!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CandleSubscriptionBanner/CandleSubscriptionBanner.tsx







var CandleSubscriptionBanner = function(param) {
    var className = param.className, position = param.position;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase_BannerBase, {
        className: (0,clsx/* default */.Z)(className, "px-8"),
        title: CandleSubscriptionBanner_messages.title,
        titleStyle: isMobile ? "eye3" : undefined,
        to: links/* default */.ZP.candleSubscription,
        height: isMobile ? 64 : 56,
        trackParams: {
            placement: "Header",
            content: "Candle subscription",
            action: "link",
            link: links/* default */.ZP.candleSubscription,
            position: position
        },
        "data-testid": "candleSubscriptionBanner"
    });
};
/* harmony default export */ const CandleSubscriptionBanner_CandleSubscriptionBanner = (CandleSubscriptionBanner);

// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/modules/subscription/subscribe/index.tsx
var subscribe = __webpack_require__(7138);
// EXTERNAL MODULE: ./src/components/dataDisplay/BackgroundImage/BackgroundImage.tsx + 1 modules
var BackgroundImage = __webpack_require__(26713);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidayBaseBanner/images/bg-mobile.jpg
const bg_mobile_namespaceObject = __webpack_require__.p + "images/bg-mobile_ca14c8.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidayBaseBanner/images/bg-desktop.jpg
const bg_desktop_namespaceObject = __webpack_require__.p + "images/bg-desktop_845c9e.jpg";
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidayBaseBanner/messages.ts
/* harmony default export */ const HolidayBaseBanner_messages = ({
    discount: {
        en: "Get {discount} off your first month"
    },
    freeTrial: {
        en: "Get your free perfume now"
    },
    freeProduct: {
        en: "Get a free product in your first order"
    },
    freeMonth: {
        en: "Get your second month for free"
    },
    noDiscountText: {
        en: "Get your first month of Scentbird for {price}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidayBaseBanner/HolidayBaseBanner.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var textByOffer = {
    freeTrial: HolidayBaseBanner_messages.freeTrial,
    free2ndMonth: HolidayBaseBanner_messages.freeMonth,
    freeProduct: HolidayBaseBanner_messages.freeProduct,
    discount: HolidayBaseBanner_messages.discount
};
var HolidayBaseBanner = function(param) {
    var position = param.position, children = param.children, dataTestId = param["data-testid"], subtitle = param.subtitle, to = param.to;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useSubscribeOffer = (0,subscribe/* useSubscribeOffer */.Hu)(), discountText = _useSubscribeOffer.discountText, formattedPriceWithDiscount = _useSubscribeOffer.formattedPriceWithDiscount, formattedPrice = _useSubscribeOffer.formattedPrice, formattedExtraShippingPrice = _useSubscribeOffer.formattedExtraShippingPrice, offerType = _useSubscribeOffer.offerType;
    var price = formattedPriceWithDiscount || formattedPrice;
    var title = _object_spread_props(_object_spread({}, textByOffer[offerType] || HolidayBaseBanner_messages.noDiscountText), {
        values: {
            discount: discountText,
            price: price,
            extraShippingPrice: formattedExtraShippingPrice
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        to: to,
        height: isMobile ? 64 : 56,
        onClick: function() {
            if (to) {
                (0,analytics/* track */.j)("Banner click", {
                    placement: "Header",
                    content: "Holiday season",
                    action: "link",
                    link: to,
                    position: position
                });
            }
        },
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
            className: "h-full w-full bg-dark-red",
            src: isMobile ? bg_mobile_namespaceObject : bg_desktop_namespaceObject,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-full flex-col items-center justify-center text-center",
                children: subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "text-cream-light",
                            message: subtitle,
                            style: "h9"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-4",
                            message: title,
                            color: "white",
                            style: "h6"
                        })
                    ]
                }) : children
            })
        })
    });
};
/* harmony default export */ const HolidayBaseBanner_HolidayBaseBanner = (HolidayBaseBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidaySeasonBanner/messages.ts
/* harmony default export */ const HolidaySeasonBanner_messages = ({
    defaultTitle: {
        en: "It’s the holiday season!"
    },
    notification: {
        en: "Order by Dec. 11 to get your holiday gifts in time"
    },
    valentinesDayNotification: {
        en: "Get your gifts in time! Order by January 29 at 11:59 EST."
    },
    title: {
        en: "{discount}% off select products"
    },
    button: {
        en: "Shop now"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/HolidaySeasonBanner/HolidaySeasonBanner.tsx
function HolidaySeasonBanner_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HolidaySeasonBanner_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HolidaySeasonBanner_define_property(target, key, source[key]);
        });
    }
    return target;
}
function HolidaySeasonBanner_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function HolidaySeasonBanner_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        HolidaySeasonBanner_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var HolidaySeasonBanner = function(props) {
    var discount = props.discount, position = props.position, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "holidaySeasonBanner" : tmp;
    var isGiftHubNotificationEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftHubNotification);
    var isGiftHubValentinesNotificationMessageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftHubValentinesNotificationMessage);
    var notificationMessage = isGiftHubValentinesNotificationMessageEnabled ? HolidaySeasonBanner_messages.valentinesDayNotification : HolidaySeasonBanner_messages.notification;
    var holidayMessage = isGiftHubNotificationEnabled ? notificationMessage : HolidaySeasonBanner_messages.defaultTitle;
    var message = discount ? HolidaySeasonBanner_object_spread_props(HolidaySeasonBanner_object_spread({}, HolidaySeasonBanner_messages.title), {
        values: {
            discount: discount
        }
    }) : holidayMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidayBaseBanner_HolidayBaseBanner, {
        position: position,
        to: discount ? links/* default */.ZP.shop.holiday : links/* default */.ZP.gifts,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex h-full items-center justify-center gap-16 px-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "flex-1 text-white",
                    message: message,
                    style: "h8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "px-8",
                    size: 38,
                    noPadding: true,
                    title: HolidaySeasonBanner_messages.button
                })
            ]
        })
    });
};
/* harmony default export */ const HolidaySeasonBanner_HolidaySeasonBanner = (HolidaySeasonBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BlackFridayBanner/messages.ts
/* harmony default export */ const BlackFridayBanner_messages = ({
    subtitle: {
        en: "black friday special"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BlackFridayBanner/BlackFridayBanner.tsx





var BlackFridayBanner = function(param) {
    var position = param.position;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidayBaseBanner_HolidayBaseBanner, {
        subtitle: BlackFridayBanner_messages.subtitle,
        to: links/* default */.ZP.subscribe,
        position: position,
        "data-testid": "blackFridayBanner"
    });
};
/* harmony default export */ const BlackFridayBanner_BlackFridayBanner = (BlackFridayBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CyberMondayBanner/messages.ts
/* harmony default export */ const CyberMondayBanner_messages = ({
    subtitle: {
        en: "cyber monday special"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/CyberMondayBanner/CyberMondayBanner.tsx





var CyberMondayBanner = function(param) {
    var position = param.position;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidayBaseBanner_HolidayBaseBanner, {
        subtitle: CyberMondayBanner_messages.subtitle,
        to: links/* default */.ZP.subscribe,
        position: position,
        "data-testid": "cyberMondayBanner"
    });
};
/* harmony default export */ const CyberMondayBanner_CyberMondayBanner = (CyberMondayBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/MothersDayBanner/MothersDayBanner.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const MothersDayBanner_module = ({"banner":"O54BU_"});
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/MothersDayBanner/messages.ts
/* harmony default export */ const MothersDayBanner_messages = ({
    title: {
        en: "Shop the mothers day gift guide"
    },
    button: {
        en: "Shop now"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/MothersDayBanner/MothersDayBanner.tsx










var HEIGHT_DESKTOP = 56;
var HEIGHT_MOBILE = 64;
var MothersDayBanner = function(props) {
    var position = props.position;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        className: MothersDayBanner_module.banner,
        to: links/* default */.ZP.gifts,
        height: isMobile ? HEIGHT_MOBILE : HEIGHT_DESKTOP,
        trackParams: {
            action: "link",
            content: "Marketing promo",
            contentDetails: "Mother’s day",
            link: links/* default */.ZP.gifts,
            placement: "Header",
            position: position
        },
        "data-testid": "holidayMothersDayBanner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex h-full items-center justify-center", isMobile ? "gap-40" : "gap-16"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: MothersDayBanner_messages.title,
                    color: "white",
                    style: isMobile ? "h9" : "h8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "px-8",
                    size: 38,
                    noPadding: true,
                    title: MothersDayBanner_messages.button
                })
            ]
        })
    });
};
/* harmony default export */ const MothersDayBanner_MothersDayBanner = (MothersDayBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/FathersDayBanner/messages.ts
/* harmony default export */ const FathersDayBanner_messages = ({
    title: {
        en: "Shop the dads & grads gift guide"
    },
    button: {
        en: "Shop now"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/FathersDayBanner/FathersDayBanner.tsx









var FathersDayBanner_HEIGHT_DESKTOP = 56;
var FathersDayBanner_HEIGHT_MOBILE = 64;
var bgClassName = "bg-[linear-gradient(90deg,_#d6a77b_0.76%,_#a57142_50.01%,_#ddac7f_100%)]";
var FathersDayBanner = function(props) {
    var position = props.position;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        className: bgClassName,
        to: links/* default */.ZP.gifts,
        height: isMobile ? FathersDayBanner_HEIGHT_MOBILE : FathersDayBanner_HEIGHT_DESKTOP,
        trackParams: {
            action: "link",
            content: "Marketing promo",
            contentDetails: "Father’s day",
            link: links/* default */.ZP.gifts,
            placement: "Header",
            position: position
        },
        "data-testid": "holidayFathersDayBanner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex h-full items-center justify-center", isMobile ? "gap-40" : "gap-16"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: FathersDayBanner_messages.title,
                    color: "white",
                    style: isMobile ? "h9" : "h8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "px-8",
                    size: 38,
                    noPadding: true,
                    title: FathersDayBanner_messages.button
                })
            ]
        })
    });
};
/* harmony default export */ const FathersDayBanner_FathersDayBanner = (FathersDayBanner);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(33273);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/modules/subscription/resubscribe/useResubscribeOffer.tsx
var useResubscribeOffer = __webpack_require__(16776);
// EXTERNAL MODULE: ./src/modules/subscription/prices/index.ts + 1 modules
var prices = __webpack_require__(81223);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/compositions/buttons/ResubscribeButton/ResubscribeButton.tsx
var ResubscribeButton = __webpack_require__(53197);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/ResubscribeBanner/messages.ts
/* harmony default export */ const ResubscribeBanner_messages = ({
    noDiscount: {
        en: "Resubscribe today to access our catalog of over 700 scents."
    },
    discount: {
        en: "Resubscribe and get your next month for {priceWithDiscount}."
    },
    percentOff: {
        en: "Take {eventOffer} your first month back when you resubscribe."
    },
    freeProduct: {
        en: "Resubscribe and get a FREE fragrance in your next order."
    },
    freeCase: {
        en: "Resubscribe and get a FREE case in your next order."
    },
    freeMonth: {
        en: "Resubscribe today, and your next month is FREE."
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/ResubscribeBanner/ResubscribeBanner.tsx
function ResubscribeBanner_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ResubscribeBanner_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ResubscribeBanner_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ResubscribeBanner_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ResubscribeBanner_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ResubscribeBanner_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}














var ResubscribeBanner = function() {
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useResubscribeOffer = (0,useResubscribeOffer/* useResubscribeOffer */.W)(), offer = _useResubscribeOffer.offer, couponCode = _useResubscribeOffer.couponCode, isCouponDataFetching = _useResubscribeOffer.isFetching, eventOffer = _useResubscribeOffer.eventOffer;
    var _usePrices = (0,prices/* usePrices */.h)({
        couponCode: couponCode,
        skip: isCouponDataFetching
    }), priceWithDiscount = _usePrices.formattedPriceWithDiscount, isPricesFetching = _usePrices.isFetching;
    var isResubGoldColorEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.resubGoldColor) === "b";
    var isFetching = isCouponDataFetching || isPricesFetching;
    var text = offer.startsWith("off") ? ResubscribeBanner_messages.percentOff : ResubscribeBanner_messages[offer];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBannerContainer/* default */.Z, {
        className: isResubGoldColorEnabled ? "bg-gold-70" : "bg-red",
        height: 64,
        loading: isFetching,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: (0,clsx/* default */.Z)("flex  items-center", isMobile ? "justify-between" : "justify-center"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: isMobile ? "sh6" : "sh5",
                    message: ResubscribeBanner_object_spread_props(ResubscribeBanner_object_spread({}, text), {
                        values: {
                            priceWithDiscount: priceWithDiscount,
                            eventOffer: eventOffer
                        }
                    }),
                    html: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResubscribeButton/* default */.Z, {
                    className: (0,clsx/* default */.Z)("max-w-[128rem] flex-none", isMobile ? "ml-12" : "ml-24"),
                    title: messages/* default */.Z.resubscribe,
                    placement: "Header",
                    size: 38
                })
            ]
        })
    });
};
/* harmony default export */ const ResubscribeBanner_ResubscribeBanner = (ResubscribeBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/DriftSubscriptionTextBanner/messages.ts
/* harmony default export */ const DriftSubscriptionTextBanner_messages = ({
    title: {
        en: "Introducing car scent club by drift"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/DriftSubscriptionTextBanner/DriftSubscriptionTextBanner.tsx







var DriftSubscriptionTextBanner = function(param) {
    var className = param.className, _param_position = param.position, position = _param_position === void 0 ? 1 : _param_position;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase_BannerBase, {
        className: (0,clsx/* default */.Z)(className, "px-8 text-center"),
        title: DriftSubscriptionTextBanner_messages.title,
        to: links/* default */.ZP.driftSubscription,
        height: isMobile ? 64 : 56,
        trackParams: {
            placement: "Header",
            content: "Drift subscription",
            action: "link",
            link: links/* default */.ZP.driftSubscription,
            position: position
        },
        html: true,
        "data-testid": "driftSubscriptionTextBanner"
    });
};
/* harmony default export */ const DriftSubscriptionTextBanner_DriftSubscriptionTextBanner = (DriftSubscriptionTextBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BfcmBanner/messages.ts
/* harmony default export */ const BfcmBanner_messages = ({
    title: {
        en: "Our biggest sale of the year [get 20% off]"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/BfcmBanner/BfcmBanner.tsx





var BfcmBanner = function(param) {
    var position = param.position;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidayBaseBanner_HolidayBaseBanner, {
        position: position,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex h-full items-center",
            "data-testid": "bfcmBanner",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "flex-1 text-white",
                message: BfcmBanner_messages.title,
                style: "h8"
            })
        })
    });
};
/* harmony default export */ const BfcmBanner_BfcmBanner = (BfcmBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/GiftSubscriptionBanner/messages.ts
/* harmony default export */ const GiftSubscriptionBanner_messages = ({
    title: {
        en: "It's not too late! [gift a subscription]"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/components/GiftSubscriptionBanner/GiftSubscriptionBanner.tsx





var GiftSubscriptionBanner = function(param) {
    var position = param.position;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidayBaseBanner_HolidayBaseBanner, {
        position: position,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex h-full items-center",
            "data-testid": "giftSubscriptionBanner",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "flex-1 text-white",
                message: GiftSubscriptionBanner_messages.title,
                style: "h8"
            })
        })
    });
};
/* harmony default export */ const GiftSubscriptionBanner_GiftSubscriptionBanner = (GiftSubscriptionBanner);

;// CONCATENATED MODULE: ./src/compositions/Header/components/Banner/Banner.tsx





















var Banner = function() {
    var _useBanner = util_useBanner(), isFetching = _useBanner.isFetching, isCardUpdateBannerVisible = _useBanner.isCardUpdateBannerVisible, isSubscribeBannerVisible = _useBanner.isSubscribeBannerVisible, isUndeliverableBannerVisible = _useBanner.isUndeliverableBannerVisible, isTossInBannerVisible = _useBanner.isTossInBannerVisible, isPrivateSaleBannerVisible = _useBanner.isPrivateSaleBannerVisible, isUnskipBannerVisible = _useBanner.isUnskipBannerVisible, isCandleSubscriptionBannerVisible = _useBanner.isCandleSubscriptionBannerVisible, isHolidayBannerVisible = _useBanner.isHolidayBannerVisible, isHolidayBanner15Visible = _useBanner.isHolidayBanner15Visible, isHolidayBanner20Visible = _useBanner.isHolidayBanner20Visible, isHolidayMothersDayVisible = _useBanner.isHolidayMothersDayVisible, isHolidayFathersDayVisible = _useBanner.isHolidayFathersDayVisible, isBlackFridayBannerVisible = _useBanner.isBlackFridayBannerVisible, isCyberMondayBannerVisible = _useBanner.isCyberMondayBannerVisible, isResubscribeBannerVisible = _useBanner.isResubscribeBannerVisible, isDriftSubscriptionVisible = _useBanner.isDriftSubscriptionVisible, isDriftSubscriptionHasLaunchPriority = _useBanner.isDriftSubscriptionHasLaunchPriority, isBfcmBannerVisible = _useBanner.isBfcmBannerVisible, isGiftSubscriptionBannerVisible = _useBanner.isGiftSubscriptionBannerVisible;
    if (isFetching) {
        return null;
    }
    if (isUnskipBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UnskipBanner_UnskipBanner, {});
    }
    if (isCardUpdateBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardUpdateBanner_CardUpdateBanner, {});
    }
    if (isUndeliverableBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UndeliverableBanner_UndeliverableBanner, {});
    }
    if (isResubscribeBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResubscribeBanner_ResubscribeBanner, {});
    }
    if (isBlackFridayBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackFridayBanner_BlackFridayBanner, {});
    }
    if (isCyberMondayBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CyberMondayBanner_CyberMondayBanner, {});
    }
    if (isSubscribeBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeHeaderBanner/* default */.Z, {});
    }
    if (isDriftSubscriptionVisible && isDriftSubscriptionHasLaunchPriority) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DriftSubscriptionTextBanner_DriftSubscriptionTextBanner, {});
    }
    if (isHolidayBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HolidaySeasonBanner_HolidaySeasonBanner, {}, "holidayHub");
    }
    var banners = [];
    if (isBfcmBannerVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(BfcmBanner_BfcmBanner, {
            position: 0
        }, "BfcmBanner"));
    }
    if (isGiftSubscriptionBannerVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSubscriptionBanner_GiftSubscriptionBanner, {
            position: 0
        }, "GiftSubscriptionBanner"));
    }
    if (isDriftSubscriptionVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(DriftSubscriptionTextBanner_DriftSubscriptionTextBanner, {
            position: banners.length + 1
        }, "driftSubscription"));
    }
    if (isHolidayMothersDayVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(MothersDayBanner_MothersDayBanner, {
            position: banners.length + 1
        }, "holidayMothersDay"));
    }
    if (isHolidayFathersDayVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(FathersDayBanner_FathersDayBanner, {
            position: banners.length + 1
        }, "holidayFathersDay"));
    }
    if (isHolidayBanner15Visible || isHolidayBanner20Visible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(HolidaySeasonBanner_HolidaySeasonBanner, {
            discount: isHolidayBanner20Visible ? 20 : 15,
            position: banners.length + 1
        }, "holidayDiscount"));
    }
    if (isCandleSubscriptionBannerVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(CandleSubscriptionBanner_CandleSubscriptionBanner, {
            position: banners.length + 1
        }, "candleSubscription"));
    }
    if (isTossInBannerVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(TossInBanner_TossInBanner, {
            position: banners.length + 1
        }, "tossIn"));
    }
    if (isPrivateSaleBannerVisible) {
        banners.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateSaleBanner_PrivateSaleBanner, {
            position: banners.length + 1
        }, "privateSale"));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannersCarousel_BannersCarousel, {
        children: banners
    });
};
/* harmony default export */ const Banner_Banner = (Banner);


/***/ }),

/***/ 14190:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Cart_Cart)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./src/modules/cart/index.ts + 4 modules
var modules_cart = __webpack_require__(65337);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Cart/messages.ts
/* harmony default export */ const messages = ({
    label: {
        en: "cart"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Cart/Cart.tsx









var Cart = function(props) {
    var className = props.className;
    var _useCart = (0,modules_cart/* useCart */.jD)(), cart = _useCart.cart, isFetching = _useCart.isFetching;
    var intl = (0,useIntl/* default */.Z)();
    var label = intl.formatMessage(messages.label);
    (0,react.useEffect)(function() {
        void (0,manager/* preloadModal */.My)("cartModal");
    }, []);
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            className: className,
            name: "32/loader",
            color: "white"
        });
    }
    var handleClick = function() {
        (0,analytics/* track */.j)("Cart icon click");
        (0,modules_cart/* openCartModal */.kZ)({
            flow: "Cart icon"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: (0,clsx/* default */.Z)(className, "relative cursor-pointer text-white"),
        type: "button",
        "aria-label": label,
        "data-testid": "cart",
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "32/cart"
            }),
            (cart === null || cart === void 0 ? void 0 : cart.totalCount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute right-0 top-0 flex h-s16 w-s16 items-center justify-center rounded-full border-2 border-black bg-white text-eye3 text-black",
                "data-testid": "cartCount",
                children: cart.totalCount
            })
        ]
    });
};
/* harmony default export */ const Cart_Cart = (Cart);


/***/ }),

/***/ 87357:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ InAppMessagesCounter_InAppMessagesCounter)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/modules/inAppMessages/index.ts
var modules_inAppMessages = __webpack_require__(74193);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
;// CONCATENATED MODULE: ./src/compositions/Header/components/InAppMessagesCounter/messages.ts
/* harmony default export */ const messages = ({
    label: {
        en: "Notifications center"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/InAppMessagesCounter/InAppMessagesCounter.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const InAppMessagesCounter_module = ({"count":"pQUBD6","appear":"AMvzqr"});
;// CONCATENATED MODULE: ./src/compositions/Header/components/InAppMessagesCounter/InAppMessagesCounter.tsx












var InAppMessagesCounter = function(props) {
    var className = props.className;
    var _useInAppMessages = (0,modules_inAppMessages/* useInAppMessages */.W)(), unreadMessagesCount = _useInAppMessages.unreadMessagesCount, inAppMessages = _useInAppMessages.inAppMessages, isFetching = _useInAppMessages.isFetching;
    var intl = (0,useIntl/* default */.Z)();
    var label = intl.formatMessage(messages.label);
    var pathname = (0,contexts/* usePathname */.jD)();
    (0,react.useEffect)(function() {
        if (isFetching) {
            return;
        }
        (0,analytics/* track */.j)("Notifications icon display", {
            numberOfMessages: inAppMessages.length,
            numberOfUnreadMessages: unreadMessagesCount
        });
    // pathname is added to deps to track event on page changes
    }, [
        pathname,
        isFetching,
        unreadMessagesCount,
        inAppMessages
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Href/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, "relative cursor-pointer text-white"),
        to: links/* default */.ZP.inAppMessagesCenter,
        "aria-label": label,
        onClick: function() {
            (0,analytics/* track */.j)("Notifications icon click");
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "32/bell"
            }),
            unreadMessagesCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx/* default */.Z)(InAppMessagesCounter_module.count, "absolute right-0 top-0 flex h-s16 w-s16 items-center justify-center rounded-full bg-white text-eye3 text-black"),
                children: unreadMessagesCount
            }, pathname)
        ]
    });
};
/* harmony default export */ const InAppMessagesCounter_InAppMessagesCounter = (InAppMessagesCounter);


/***/ }),

/***/ 45147:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ MainHeader_MainHeader)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
;// CONCATENATED MODULE: ./src/compositions/Header/components/MainHeader/MainHeader.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const MainHeader_module = ({"header":"iFJVNB","placeholder":"E0mK8P"});
;// CONCATENATED MODULE: ./src/compositions/Header/components/MainHeader/MainHeader.tsx








var MainHeader = function(props) {
    var children = props.children, className = props.className, size = props.size;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var isCartAutoOpenEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.cartNotificationDesignUpdate) !== "b";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-stretch bg-black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: MainHeader_module.placeholder
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                id: "main-header",
                className: (0,clsx/* default */.Z)(MainHeader_module.header, className, "relative flex flex-1 items-stretch bg-black text-white", isMobile && isCartAutoOpenEnabled && "z-overlay"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
                    className: "flex w-full items-center",
                    size: size,
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ const MainHeader_MainHeader = (MainHeader);


/***/ }),

/***/ 58884:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ QueueCounter_QueueCounter)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user_user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
;// CONCATENATED MODULE: ./src/compositions/Header/components/QueueCounter/messages.ts
/* harmony default export */ const messages = ({
    label: {
        en: "queue"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/QueueCounter/QueueCounter.tsx








var QueueCounter = function() {
    var _user_analyticsMetadata;
    var _useUser = (0,user_user/* useUser */.a)(), user = _useUser.user, isFetching = _useUser.isFetching;
    var productsCount = (user === null || user === void 0 ? void 0 : (_user_analyticsMetadata = user.analyticsMetadata) === null || _user_analyticsMetadata === void 0 ? void 0 : _user_analyticsMetadata.productsInQueueQty) || 0;
    var intl = (0,useIntl/* default */.Z)();
    var label = intl.formatMessage(messages.label);
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "32/loader",
            color: "white"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Href/* default */.Z, {
        className: "relative cursor-pointer text-white",
        to: links/* default */.ZP.queue,
        "aria-label": label,
        "data-testid": "queue",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "32/queue"
            }),
            productsCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute right-0 top-0 flex h-s16 w-s16 items-center justify-center rounded-full border-2 border-black bg-white text-eye3 text-black",
                "data-testid": "cartCount",
                children: productsCount
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: "absolute right-0 top-0 rounded-full border border-black",
                name: "16/info",
                color: "red"
            })
        ]
    });
};
/* harmony default export */ const QueueCounter_QueueCounter = (QueueCounter);


/***/ }),

/***/ 5264:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78364);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2487);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31627);
/* harmony import */ var compositions_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8323);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var ReferralNavItem = function(param) {
    var textClassName = param.textClassName, _param_spanClassName = param.spanClassName, spanClassName = _param_spanClassName === void 0 ? "" : _param_spanClassName, _param_freeFragranceClassName = param.freeFragranceClassName, freeFragranceClassName = _param_freeFragranceClassName === void 0 ? "" : _param_freeFragranceClassName, _param_style = param.style, style = _param_style === void 0 ? null : _param_style;
    var _useReferralInvites = (0,modules_user__WEBPACK_IMPORTED_MODULE_2__/* .useReferralInvites */ .n)(), available = _useReferralInvites.stats.available;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(textClassName),
        tag: "span",
        message: _object_spread_props(_object_spread({}, compositions_navigation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.newReferral), {
            values: {
                available: available,
                spanClassName: spanClassName,
                freeFragranceClassName: freeFragranceClassName
            }
        }),
        style: style,
        html: true
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReferralNavItem);


/***/ }),

/***/ 24324:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Search_Search)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
;// CONCATENATED MODULE: ./src/compositions/Header/components/Search/messages.ts
/* harmony default export */ const messages = ({
    label: {
        en: "search"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Header/components/Search/Search.tsx







var Search = function() {
    var intl = (0,useIntl/* default */.Z)();
    var label = intl.formatMessage(messages.label);
    (0,react.useEffect)(function() {
        void (0,manager/* preloadModal */.My)("searchModal");
    }, []);
    var handleClick = function() {
        (0,analytics/* track */.j)("Search input click");
        (0,manager/* openModal */.h7)("searchModal");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "cursor-pointer text-white",
        type: "button",
        "aria-label": label,
        "data-testid": "search",
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: "32/search"
        })
    });
};
/* harmony default export */ const Search_Search = (Search);


/***/ }),

/***/ 50623:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69541);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66226);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84584);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17382);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31627);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73358);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21182);










var UserNavWrapper = function(param) {
    var children = param.children, withRedirect = param.withRedirect;
    var _useUser = (0,modules_user__WEBPACK_IMPORTED_MODULE_3__/* .useUser */ .a)(), isLoggedIn = _useUser.isLoggedIn, isFetching = _useUser.isFetching;
    var currentUrl = (0,router__WEBPACK_IMPORTED_MODULE_4__/* .useLocationState */ .KJ)().currentUrl;
    if (isFetching) {
        return null;
    }
    if (!isLoggedIn) {
        // ATTN it shouldn't cause any issues with landings, but we can exclude landings if it will
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            to: "".concat(links__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP.login).concat(withRedirect ? "?redirect=".concat(encodeURIComponent(currentUrl)) : ""),
            onClick: function() {
                (0,analytics__WEBPACK_IMPORTED_MODULE_7__/* .track */ .j)("Login button click");
            },
            "data-testid": "loginButton",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                message: components_inputs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z.login,
                style: "t2"
            })
        });
    }
    return children;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UserNavWrapper);


/***/ }),

/***/ 6935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83464);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69541);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(83901);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47361);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91339);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45184);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17382);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2487);
/* harmony import */ var modules_academy__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74317);
/* harmony import */ var compositions_navigation__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8323);
/* harmony import */ var compositions_Header_components_ReferralNavItem_ReferralNavItem__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5264);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}














var useUserNav = function() {
    var _subscription_stateOptions, _subscription_plan;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().isMobile;
    var logout = (0,modules_user__WEBPACK_IMPORTED_MODULE_7__/* .useLogout */ .aU)();
    var hasBillingAddress = (0,modules_user__WEBPACK_IMPORTED_MODULE_8__/* .useUser */ .a)().hasBillingAddress;
    var subscription = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_9__/* .useSubscription */ .m)().subscription;
    var isSubscribed = subscription === null || subscription === void 0 ? void 0 : subscription.isSubscribed;
    var hasNeverSubscribed = subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed;
    // hide upgrade link for users with 3 products per month plan
    var canUpgradeProductsCount = (subscription === null || subscription === void 0 ? void 0 : (_subscription_stateOptions = subscription.stateOptions) === null || _subscription_stateOptions === void 0 ? void 0 : _subscription_stateOptions.canUpgrade) && (subscription === null || subscription === void 0 ? void 0 : (_subscription_plan = subscription.plan) === null || _subscription_plan === void 0 ? void 0 : _subscription_plan.productsPerPeriod) < 3;
    var _useReferralInvites = (0,modules_user__WEBPACK_IMPORTED_MODULE_10__/* .useReferralInvites */ .n)(), available = _useReferralInvites.stats.available;
    var isReferralItemVisible = Boolean(available);
    var data = (0,modules_academy__WEBPACK_IMPORTED_MODULE_11__/* .useAcademyCoursePromo */ .mF)().data;
    var isScentbirdAcademyCourseVisible = (data === null || data === void 0 ? void 0 : data.status) === "PURCHASED";
    return (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        var data = [
            {
                id: "user-membership",
                title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.membership,
                list: [
                    {
                        id: "user-membership-queue",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.queue,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.queue
                    },
                    {
                        id: "user-membership-orders",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.orderHistory,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.orderHistory
                    },
                    !hasNeverSubscribed && {
                        id: "user-membership-subscription",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.manageSubscription,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.subscriptionStatus
                    },
                    canUpgradeProductsCount && {
                        id: "user-membership-upgrade",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.upgrade,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.upgradeProduct
                    },
                    // TODO handle resubscribe? - added on 07.12.2021 by sonatskiy
                    hasNeverSubscribed && {
                        id: "user-membership-subscribe",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.subscribe,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.subscribe
                    },
                    isScentbirdAcademyCourseVisible && {
                        id: "user-scentbird-academy",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.scentbirdAcademy,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.academy.root,
                        label: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.labels["new"]
                    }
                ].filter(Boolean)
            },
            {
                id: "user-account",
                title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.account,
                list: [
                    hasBillingAddress && {
                        id: "user-account-billing",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.billingInfo,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.billing
                    },
                    {
                        id: "user-account-shipping",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.shippingInfo,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.shipping
                    },
                    {
                        id: "user-account-personal",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.personalInfo,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.personalInfo
                    },
                    isSubscribed && {
                        id: "user-account-reviews",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.reviews,
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.profile.reviews
                    },
                    isReferralItemVisible && {
                        id: "referral-nav-item",
                        to: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.invite,
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.referralProgram,
                        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(compositions_Header_components_ReferralNavItem_ReferralNavItem__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            spanClassName: "text-white align-text-bottom ".concat(isMobile ? "bg-gold-70" : "bg-gold-50"),
                            freeFragranceClassName: isMobile ? "text-gold-70" : "text-gold-30"
                        })
                    },
                    {
                        id: "user-account-help",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.support,
                        toTab: "https://scentbird.zendesk.com/hc/en-us"
                    },
                    {
                        id: "user-account-logoff",
                        title: compositions_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.logoff,
                        href: links__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP.logoff,
                        onClick: function() {
                            var _ref = _async_to_generator(function(event) {
                                var error;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            event.preventDefault();
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                logout()
                                            ];
                                        case 2:
                                            _state.sent();
                                            window.location.reload();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            error = _state.sent();
                                            (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* .processError */ .wY)(error);
                                            return [
                                                3,
                                                4
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(event) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    }
                ].filter(Boolean)
            }
        ];
        return data.filter(Boolean);
    }, [
        canUpgradeProductsCount,
        hasBillingAddress,
        hasNeverSubscribed,
        isReferralItemVisible,
        isSubscribed,
        isScentbirdAcademyCourseVisible,
        logout,
        isMobile
    ]);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useUserNav);


/***/ }),

/***/ 98539:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28950);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47361);
/* harmony import */ var modules_brands__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14159);
/* harmony import */ var compositions_banners_BannerBase_BannerBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76133);






// TODO: Merge with DynamicNavigationBanner after strapi banners refactoring — added on 17-04-2023 by algeas
var StrapiWSTONavigationBanner = function(props) {
    var _strapiWSTONavigationData_banners;
    var placement = props.placement, onClick = props.onClick, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "brandsBanner" : tmp;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isMobile;
    var strapiWSTONavigationData = (0,modules_brands__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var strapiWSTONavigationBannerData = strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : (_strapiWSTONavigationData_banners = strapiWSTONavigationData.banners) === null || _strapiWSTONavigationData_banners === void 0 ? void 0 : _strapiWSTONavigationData_banners[placement];
    if (!strapiWSTONavigationBannerData) {
        return null;
    }
    var to = strapiWSTONavigationBannerData.to, name = strapiWSTONavigationBannerData.name;
    var background = strapiWSTONavigationBannerData.background;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(compositions_banners_BannerBase_BannerBase__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        to: to,
        bgImage: isMobile ? background === null || background === void 0 ? void 0 : background.mobile : background === null || background === void 0 ? void 0 : background.desktop,
        content: "Featured brand",
        "data-testid": dataTestId,
        onClick: onClick,
        trackParams: {
            productBrand: name
        }
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StrapiWSTONavigationBanner);


/***/ })

}]);